export function getCurrencySymbol(currency) {
    if(currency === 'EUR') {
        return '€';
    }
    return currency;
}

const PENDING_SIGNUP_EMAIL_KEY = "pendingSignupEmail";
const PENDING_SIGNUP_USER_ID_KEY = "pendingSignupUserId";
const PENDING_PLAN_ID_KEY = "pendingPlanId";

const isBrowser = typeof window !== "undefined";

export function getApiErrorMessage(error, fallbackMessage) {
    const data = error?.response?.data;

    if (data?.errorMessage) {
        return data.errorMessage;
    }

    if (typeof data?.message === "string" && data.message !== "") {
        return data.message;
    }

    if (data?.errors && typeof data.errors === "object") {
        const firstError = Object.values(data.errors)[0];

        if (Array.isArray(firstError) && firstError[0]) {
            return firstError[0];
        }

        if (typeof firstError === "string") {
            return firstError;
        }
    }

    return fallbackMessage;
}

export function getApiErrorCode(error) {
    return error?.response?.data?.errorCode || "";
}

export function setPendingSignupData({ email, userId, planId }) {
    if (!isBrowser) {
        return;
    }

    if (email) {
        window.localStorage.setItem(PENDING_SIGNUP_EMAIL_KEY, email);
    } else {
        window.localStorage.removeItem(PENDING_SIGNUP_EMAIL_KEY);
    }

    if (userId) {
        window.localStorage.setItem(PENDING_SIGNUP_USER_ID_KEY, String(userId));
    } else {
        window.localStorage.removeItem(PENDING_SIGNUP_USER_ID_KEY);
    }

    if (planId) {
        window.localStorage.setItem(PENDING_PLAN_ID_KEY, String(planId));
    } else {
        window.localStorage.removeItem(PENDING_PLAN_ID_KEY);
    }
}

export function clearPendingSignupData({ keepPlanId = false } = {}) {
    if (!isBrowser) {
        return;
    }

    window.localStorage.removeItem(PENDING_SIGNUP_EMAIL_KEY);
    window.localStorage.removeItem(PENDING_SIGNUP_USER_ID_KEY);
    window.localStorage.removeItem("signUpEmail");
    window.localStorage.removeItem("userId");
    window.localStorage.removeItem("password");
    window.localStorage.removeItem("repeat");

    if (!keepPlanId) {
        window.localStorage.removeItem(PENDING_PLAN_ID_KEY);
    }
}

export function getPendingSignupEmail() {
    if (!isBrowser) {
        return "";
    }

    return window.localStorage.getItem(PENDING_SIGNUP_EMAIL_KEY) || "";
}

export function getPendingSignupUserId() {
    if (!isBrowser) {
        return "";
    }

    return window.localStorage.getItem(PENDING_SIGNUP_USER_ID_KEY) || "";
}

export function getPendingPlanId() {
    if (!isBrowser) {
        return "";
    }

    return window.localStorage.getItem(PENDING_PLAN_ID_KEY) || "";
}

export function buildDetailsRoute(planId = "") {
    if (!planId) {
        return "/details";
    }

    return `/details?planId=${encodeURIComponent(planId)}`;
}

export function getPostAuthRoute(authUser, planId = getPendingPlanId()) {
    if (!authUser?.clinic) {
        return buildDetailsRoute(planId);
    }

    if (
        authUser.clinic.paymentExcluded &&
        authUser.clinic.businessPlan?.type === 1 &&
        authUser.clinic.languages?.length > 1
    ) {
        return "/dashboard-paid";
    }

    return "/dashboard";
}
